import { Field } from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';
import TextInput from 'src/components/input/TextInput';
import InputField from 'src/components/input/InputField';

export default function PostalCode({ country }: { country: string }) {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <InputField
      mb="0.5rem"
      errorMessage={String(errors.postalCode?.message)}
      invalid={!!errors.postalCode}
    >
      <Field.Label htmlFor="postalCode">{country === 'US' ? 'ZIP' : 'Postal Code'}</Field.Label>
      <TextInput
        {...register('postalCode')}
        id="postalCode"
        inputGroupProps={{ height: 'unset' }}
      />
    </InputField>
  );
}
